<template>
  <v-container
    d-flex
    align-content-center
    fill-height
    fluid
    style="height: 100vh"
    class="pt-0"
  >
    <v-row justify="center">
      <v-col cols="12" sm="12" md="auto" class="pa-4" style="max-width: 100%">
        <chain-edit
          :mode="mode"
          :chain="chain"
          @confirm="$emit('close')"
          @cancel="$emit('close')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ChainEdit from './Overlay/ChainEdit.vue';

export default {
  components: {
    ChainEdit,
  },
  props: {
    mode: {
      type: String,
      default: '',
    },
    chain: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {},
};
</script>

<style></style>
